export default function goToUrl(url) {
	window.location.href = url;
}



// WEBPACK FOOTER //
// ./src/shared/util/goToUrl.js